import React from 'react';

interface ShowEndedGroupsCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
}

export const ShowEndedGroupsCheckbox = (
    {
        checked,
        onChange,
        disabled = false,
    }: ShowEndedGroupsCheckboxProps
) => {
    return (
        <label className="show-ended-groups-checkbox">
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(event) => onChange(event.target.checked)}
            />
            <span>Показывать законченные группы</span>
        </label>
    );
};
